import React from 'react'

export default function Hidden(props) {
  return <div>
    <small className="text-muted">This hotspot won't show up currently.</small>
  </div>
}
